import React, { Component } from "react";
import store from "store";
import detector from "detector";

import getPlanSeo from "../../../common/helpers/getPlanSeo";
import Seo from "../../../common/helpers/seo";
import { ICommonTaskProps } from "../../../common/types";

import routing from "../../routing";
import { host } from "../../paths";
import socket from "../../socket";
import { setItem, hasItem, getItem, removeItem } from "../../cookie";

import { LoaderWrapper } from "../../components/Loader";
import Retry from "../../components/Retry";
import NotFound from "../../components/NotFound";
import PageLoader from "../../components/PageLoader";
import TaskSwitch from "../../components/TaskSwitch";
import Experience from "../../components/Experience";
import TaskDescriptionModal from "../../components/TaskDescriptionModal";

import ConnectModal from "./ConnectModal";
import DecorationModal from "./DecorationModal";

import Menu from "./Menu";

import { StyledLoader, PlayWrapper } from "./styles";
import messages from "./messages";
import { IProps, IResult, IState } from "./interfaces";
import { IStudent } from "./Menu/interfaces";

class PlayPlan extends Component<IProps, IState> {
    savedStates: any[] = [];
    unmounted = false;
    timer: ReturnType<typeof setTimeout>;
    handleReset?: () => void;
    saveState?: () => any;
    restoreState?: (state: any) => void;
    showSolution?: () => void;
    handleExperienceCompleted?: (remainOnScreen?: boolean) => void;
    constructor(props: IProps) {
        super(props);
        this.state = {
            stop: false,
            taskIndex: 0,
            emptyHistory: true,
            isDescriptionVisible: !!process.env.WEBPACK,
            isExperience: false,
            isLow: false,
            displaySelection: false,
            modalNotFound: false,
            key: "",
            code: "",
            publicView: false,
            shareModal: false,
            share: false,
            paging: false,
            students: [],
            results: [],
        };
        if (!process.env.WEBPACK) {
            return;
        }

        let { plan, match, history, user } = props;
        const id = match.params.id;
        if (!user.loggedIn && store.get("play-plan-id") !== id) {
            history.replace(`/${routing.publicPlan}/${id}`);
            return;
        }
        const isExperience = history.location.pathname.indexOf(routing.experience) !== -1;
        if (plan && plan._id !== id) {
            this.state = {
                ...this.state,
                stop: true,
                taskIndex: isExperience ? null : 0,
                emptyHistory: window.historyList.length === 0,
                isExperience,
            };
            props.resetPlan(() => {
                setTimeout(this.getPlan);
            });
        } else {
            if (isExperience && plan && !plan.experience?.enabled) {
                props.history.replace(`/${routing.publicPlay}/${id}`);
                return;
            }
            this.state = {
                ...this.state,
                taskIndex: isExperience ? null : 0,
                emptyHistory: window.historyList.length === 0,
                isExperience,
            };
            setTimeout(this.getPlan);
        }
    }

    componentDidMount() {
        if (!this.state.isExperience) {
            this.loadDisplay();
        } else {
            this.setState({
                isLow: false,
            })
        }
    }
    loadDisplay = () => {
        let isLow = true;
        if (hasItem("isLow")) isLow = getItem("isLow") === "1";
        else setItem("isLow", "1", 60 * 60 * 24 * 365 * 3, "/");
        const displaySelection = !hasItem("isLowSelected");
        this.setState({
            isLow,
            displaySelection,
        });
    };
    getPlan = () => {
        const {
            plan,
            getPlan,
            history,
            match: { params },
            initialStudents,
            initialResults,
        } = this.props;
        const { pathname } = history.location;
        if (!plan || (plan as {
            loading?: boolean,
            error?: boolean,
            notFound?: boolean,
        }).error) {
            getPlan(pathname, res => {
                const { data } = res;
                if (!data.found) {
                    this.setState({ modalNotFound: true });
                    return;
                }
                if (this.state.isExperience && !data.plan.experience?.enabled) {
                    history.replace(`/${routing.publicPlay}/${params.id}`);
                    this.setState({ taskIndex: 0, isExperience: false });
                    return;
                }
            });
        }

        let share = false;
        if (pathname.slice(1, routing.share.length + 1) === routing.share) {
            share = true;
            let hasKey = hasItem("room-key");
            setTimeout(() => {
                let samePlan = false;
                if (hasItem("room-plan-id")) {
                    if (getItem("room-plan-id") === params.id) {
                        samePlan = true;
                    }
                }
                if (hasKey && samePlan) {
                    let key = getItem("room-key")!;
                    let code = getItem("room-secret")!;
                    this.startSocket(key, code, 0);
                } else {
                    removeItem("room-key");
                    removeItem("room-secret");
                    removeItem("room-plan-id");
                    this.startClassroom();
                }
            });
        }
        let publicView =
            pathname.slice(1, routing.publicPlay.length + 1) === routing.publicPlay ||
            pathname.slice(1, routing.share.length + 1) === routing.share;
        this.setState({
            publicView,
            modalNotFound: false,
            stop: false,
            students: [],
            results: [],
            key: null,
            shareModal: share && !this.state.displaySelection,
            share,
            taskIndex: this.state.isExperience ? null : 0,
            ...(initialStudents && { students: initialStudents }),
            ...(initialResults && { results: initialResults }),
        });
        if (!this.props.isSimulation && detector.os.name !== "ios") {
            document.body.style.overflowY = "hidden";
        }
    };

    startClassroom = (n = 0) => {
        const { post } = this.props;
        post(
            "new-classroom",
            {
                planId: this.props.match.params.id,
            },
            res => {
                const { data } = res;
                if (this.unmounted) {
                    return;
                }
                n++;
                const { key, code } = data;
                if (!key) {
                    return;
                }
                const { params } = this.props.match;
                setItem("room-key", key, 60 * 60, "/");
                setItem("room-secret", code, 60 * 60, "/");
                setItem("room-plan-id", params.id, 60 * 60, "/");
                this.timer = setTimeout(() => {
                    if (n > 20) return;
                    this.startSocket(key, code, n);
                }, n * 50);
            }
        );
    };

    startSocket = (key: string, code: string, n: number) => {
        this.setState({ key, code });
        socket.start();
        if (!socket.com) return;

        socket.com.on("master-restart", () => {
            removeItem("room-key");
            removeItem("room-secret");
            socket.stop();
            this.startClassroom(n);
        });

        socket.com.on("connect", () => {
            socket.com!.emit("classroom-master", { key, code });
        });
        socket.com.on("task-index", (data: { taskIndex: number }) => {
            this.setState({ paging: true, taskIndex: data.taskIndex }, () => {
                this.setState({ paging: false });
            });
        });

        socket.com.on("started-at", (data: { startedAt: number }) => {
            this.setState({ startedAt: data.startedAt });
        });

        socket.com.on("students-and-results", (data: { students: IState["students"], results: string[][] }) => {
            const { students, results: _results } = data;
            const results: IState["results"] = [];
            _results.forEach((result, rIndex) => {
                if (result) {
                    result.forEach((student, index) => {
                        if (!results[rIndex]) results[rIndex] = [];
                        results[rIndex][index] = {
                            studentId: student,
                            result: index,
                        };
                    });
                }
            });

            this.setState({ students, results });
        });
        socket.com.on("student-joined", (data: IStudent) => {
            const students = [...this.state.students, { name: data.name, studentId: data.studentId }];
            this.setState({ students });
        });
        socket.com.on("student-completed", (data: IResult) => {
            const { studentId, result } = data;

            const { results, taskIndex } = this.state;
            if (!results[taskIndex!]) results[taskIndex!] = [];
            results[taskIndex!].push({ studentId, result });
            this.setState({ results });
        });
        socket.com.on("close-classroom", () => {
            removeItem("room-key");
            removeItem("room-secret");
            socket.stop();
            if (window.historyList.length === 0) {
                this.props.history.push("/");
            } else {
                this.props.history.goBack();
            }
        });
        socket.com.on("set-class-id", ({ classId }: { classId: string }) => {
            this.setState({ classId });
        })
    };
    componentWillUnmount() {
        if (socket.com) {
            socket.stop();
        }
        this.unmounted = true;
        clearTimeout(this.timer);
        if (!this.props.isSimulation) {
            document.body.style.overflowY = "";
        }
    }
    closeClassroom = () => {
        socket.com!.emit("close-classroom", { code: this.state.code });
    };

    setTaskIndex = (screenIndex: number | null, difficulty: null | "easy" | "hard") => {
        const { plan } = this.props;
        const position = (screenIndex !== null) ? plan!.experience.positions[screenIndex] : null;
        let taskId: number | null;
        if (Array.isArray(position)) {
            taskId = position[difficulty === "easy" ? 0 : 1];
        } else {
            taskId = position;
        }
        let taskIndex: IState["taskIndex"] = plan!.tasks.findIndex(task => task.id === taskId);
        if (taskIndex === -1) taskIndex = null;
        this.goToPage(taskIndex);
    };

    goToPage = (taskIndex: IState["taskIndex"]) => {
        const { isExperience } = this.state;
        if (this.saveState) {
            this.savedStates[this.state.taskIndex!] = this.saveState();
        }
        this.saveState = undefined;
        this.showSolution = undefined;
        this.setState({ paging: true, taskIndex, isDescriptionVisible: false }, () => {
            this.setState({ paging: false }, () => {
                if (this.restoreState && this.savedStates[taskIndex!]) {
                    setTimeout(() => {
                        this.restoreState!(this.savedStates[taskIndex!]);
                    });
                }
                setTimeout(() => {
                    this.setState({ isDescriptionVisible: true });
                }, isExperience ? 2500 : 500);
            });
        });
    };
    restart = () => {
        this.handleReset!();
        if (socket.com) {
            const { results, taskIndex } = this.state;
            results[taskIndex!] = [];
            this.setState({ results });
            socket.com.emit("restart-task", { taskIndex: this.state.taskIndex });
        }
    };
    handleShowSolution = () => {
        this.showSolution!();
        if (this.handleExperienceCompleted) {
            this.handleExperienceCompleted(true);
        }
        if (socket.com) {
            socket.com.emit("show-solution", { taskIndex: this.state.taskIndex });
        }
    };
    switchIsLow = () => {
        let { isLow } = this.state;
        isLow = !isLow;
        this.setState({ isLow });
        setItem("isLow", isLow ? "1" : "0", 60 * 60 * 24 * 365 * 3, "/");
    };
    selectDisplay = (type: "normal" | "playful") => {
        if (type === "normal") {
            this.setState({ isLow: false, displaySelection: false });
            setItem("isLow", "0", 60 * 60 * 24 * 365 * 3, "/");
        } else {
            this.setState({ isLow: true, displaySelection: false });
            setItem("isLow", "1", 60 * 60 * 24 * 365 * 3, "/");
        }
        setItem("isLowSelected", "1", 60 * 60 * 24 * 365 * 3, "/");
        if (this.state.share) {
            this.setState({ shareModal: true });
        }
    };

    setClassId = (classId: string) => {
        socket.com!.emit("set-class-id", { classId });
    }
    render() {
        const {
            shareModal,
            key,
            share,
            students,
            modalNotFound,
            results,
            startedAt,
            paging,
            emptyHistory,
            taskIndex,
            isLow,
            displaySelection,
            isExperience,
            isDescriptionVisible,
            publicView,
            classId,
        } = this.state;
        const {
            plan,
            intl,
            intl: { formatMessage },
            isSimulation,
        } = this.props;
        if (modalNotFound) {
            return (
                <PlayWrapper>
                    <Seo title={formatMessage(messages.notFound)} type={"article"} noindex />
                    <NotFound close={this.props.history.goBack} />
                </PlayWrapper>
            );
        }
        if (!plan || (taskIndex === null && !isExperience) || (plan as {
            loading?: boolean,
            error?: boolean,
            notFound?: boolean,
        }).loading || (plan as {
            loading?: boolean,
            error?: boolean,
            notFound?: boolean,
        }).error || !plan.tasks) {
            if (plan && (plan as {
                loading?: boolean,
                error?: boolean,
                notFound?: boolean,
            }).error) {
                return (
                    <StyledLoader>
                        <LoaderWrapper><Retry onClick={this.getPlan} /></LoaderWrapper>
                    </StyledLoader>
                );
            }
            return (
                <PageLoader isFullPage />
            )
        }
        const task = plan.tasks[taskIndex!];
        if ((!isExperience && !task) || isLow === undefined) {
            return (
                <PageLoader isFullPage />
            );
        }
        const menuProps = {
            join: {
                host,
                key,
            },
            students,
            results,
            startedAt,
            closeClassroom: this.closeClassroom,
        };
        return (
            <PlayWrapper isSimulation={isSimulation}>
                <Seo {...getPlanSeo(plan, intl)} />
                <Menu
                    {...(((share && key) || isSimulation) && { ...menuProps })}
                    isSimulation={!!isSimulation}
                    plan={plan}
                    taskIndex={taskIndex}
                    emptyHistory={emptyHistory}
                    goToPage={this.goToPage}
                    restart={this.restart}
                    showSolution={this.handleShowSolution}
                    switchIsLow={this.switchIsLow}
                    isExperience={isExperience}
                />
                {!paging && !isExperience && (() => {
                    const Task = TaskSwitch(task.type) as (props: ICommonTaskProps) => JSX.Element;
                    return (
                        <Task
                            task={task as any}
                            playPlan
                            setReset={f => (this.handleReset = f)}
                            saveState={saveState => (this.saveState = saveState)}
                            restoreState={restoreState => (this.restoreState = restoreState)}
                            showSolution={showSolution => (this.showSolution = showSolution)}
                            isLow={isLow}
                            plan={plan}
                            completed={type => {
                                this.props.taskCompleted({
                                    type,
                                    editor: false,
                                    planId: plan._id,
                                    page: share ? "share" : publicView ? "public" : "private",
                                    isExperience,
                                });
                            }}
                        />
                    )
                })()}
                {isExperience && plan.experience?.enabled && (
                    <Experience
                        plan={plan}
                        setReset={f => (this.handleReset = f)}
                        saveState={saveState => (this.saveState = saveState)}
                        restoreState={restoreState => (this.restoreState = restoreState)}
                        showSolution={showSolution => (this.showSolution = showSolution)}
                        setTaskIndex={this.setTaskIndex}
                        setGiveUp={(handleGiveUp) => (this.handleExperienceCompleted = handleGiveUp)}
                        completed={type => {
                            this.props.taskCompleted({
                                type,
                                editor: false,
                                planId: plan._id,
                                page: share ? "share" : publicView ? "public" : "private",
                                isExperience,
                            });
                        }}
                    />
                )}
                {displaySelection && <DecorationModal selectDisplay={this.selectDisplay} />}

                {shareModal && (
                    <ConnectModal
                        connectKey={key}
                        plan={plan}
                        students={students}
                        setClassId={this.setClassId}
                        classId={classId}
                        close={() => this.setState({ shareModal: false })}
                    />
                )}
                {!displaySelection && !shareModal && !paging && task && isDescriptionVisible &&
                    <TaskDescriptionModal task={task} />
                }
            </PlayWrapper>
        );
    }
}

export default PlayPlan;
